import React, { type ReactNode } from 'react'
import { Box, Text } from '@mantine/core'
import AppButton from './AppButton'

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  message?: string;
  action?: { label: string; onClick: () => void };
}

export default function EmptyState ({ icon, title, message, action }: EmptyStateProps) {
  return (
    <Box sx={{ textAlign: 'center', padding: '48px 24px' }}>
      {icon && (
        <Box sx={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}>
          {icon}
        </Box>
      )}
      <Text weight={600} size="lg" sx={{ color: 'var(--gs-text)' }}>
        {title}
      </Text>
      {message && (
        <Text size="sm" mt="xs" sx={{ color: 'var(--gs-muted)' }}>
          {message}
        </Text>
      )}
      {action && (
        <AppButton variant="light" size="sm" mt="md" onClick={action.onClick}>
          {action.label}
        </AppButton>
      )}
    </Box>
  )
}
